import WatchListEntriesTable from './WatchListEntriesTable';

export default WatchListEntriesTable;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/components/watch-list-entries-table/index.js